import { Injectable } from '@angular/core';
import { Observable ,  Subject } from 'rxjs';

export class Message {
  model: string; // Fee Splits, Properties, etc
  type: string; // Post, Put, Delete, etc
  title: string;
  text: string; // Updating properites, fee splits, etc
  obj?: {};
}

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  private subject = new Subject<any>();

  constructor() { }

  sendMessage(message: Message) {
    this.subject.next(message);
  }

  clearMessage() {
    this.subject.next(null);
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}
